import { UIComponent } from "@aptus/frontend-core";
import { AutoCompleteSelect } from "components/form/autoCompleteSelect/autoCompleteSelect";
import { MainGrapeSelectProps, useMainGrapeSelect } from "./useMainGrapeSelect";

export const MainGrapeSelect: UIComponent<MainGrapeSelectProps> = (props) => (
	<AutoCompleteSelect {...useMainGrapeSelect(props)} />
);
